import { Component, OnInit, Injector, Input, ViewChild, AfterViewInit } from '@angular/core';
import { EditModalBase } from './edit-modal-base';
import { KFormItem, KformComponent } from '../kform/kform.component';
import { HttpRequestService } from 'src/app/services/http-request.service';
import { HttpResult } from 'src/app/models/Commons/HttpResult';
import { PromptService } from 'src/app/services/prompt.service';

@Component({
  selector: 'app-edit-modal',
  templateUrl: './edit-modal.component.html',
  styleUrls: ['./edit-modal.component.less']
})
export class EditModalComponent extends EditModalBase<any> implements OnInit {

  @Input()
  formItems: Array<KFormItem> = null;

  @ViewChild(KformComponent, { static: true })
  formInstance: KformComponent;

  //是否是修改模式
  private isModify: boolean = false;
  constructor(injector: Injector,
    private httpRequestService: HttpRequestService,
    private promptService: PromptService) {
    super(injector)
  }

  ngOnInit(): void {
    if (this.editData != null) {
      this.isModify = true;
    } else {
      this.isModify = false;
    }
  }

  saveModal() {
    this.loadingSave = true;
    var resultData = this.formInstance.submitForm();
    //树形选框添加默认数据处理
    this.formInstance.formItems.forEach(element => {
      if (element.controlType === "checkselect") {
        resultData[element.formControlName] = element.datadeal(resultData[element.formControlName])
      }
    });
    var data = {};
    if (this.isModify) {
      resultData[this.submitInfo.keyId ? this.submitInfo.keyId : "EntityId"] = this.editData[this.submitInfo.keyId]
      data[this.submitInfo.keyId ? this.submitInfo.keyId : "EntityId"] = this.editData[this.submitInfo.keyId]
    }
    if (this.submitInfo.injectData) {
      resultData = Object.assign({}, resultData, this.submitInfo.injectData);
    }
    data[this.submitInfo.modelName ? this.submitInfo.modelName : 'Entity'] = resultData;
    this.httpRequestService
      .httpRequest(this.submitInfo.action,
        this.submitInfo.method,
        data,
        '正在保存')
      .subscribe((result: HttpResult<any>) => {
        if (result.code == 0) {
          if (!this.isModify){
            // this.formInstance.resetForm();
          }
          this.promptService.success("保存成功").subscribe(() => {
            if (this.onRefresh != null)
              this.onRefresh();
          });
        } else {
          this.promptService.error("保存失败，" + result.message).subscribe();
        }
        this.loadingSave = false
      }, err => {
        this.loadingSave = false
      });
  }
}
